import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from "vue-router";
import { useSettingsStore } from '@/api/store/settings';
import { useUserStore } from '@/api/store/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'LogoutPage',
  setup(__props) {

const userStore = useUserStore();
const router = useRouter();

const logout = () => {
  userStore.logout();
  setTimeout(() => {
    router.push({ name: "login" });
  }, 1000);
}

logout();

return (_ctx: any,_cache: any) => {
  const _component_v_alert = _resolveComponent("v-alert")!

  return (_openBlock(), _createBlock(_component_v_alert, { type: "info" }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createTextVNode(" You will now be logged out. ", -1)
    ]))]),
    _: 1
  }))
}
}

})